import { MenuItem, FormControl, Select } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { useIntersection } from "utils/CustomHook";
import moment from "moment";

const useStyle = makeStyles((theme) => ({
  iih_selectbox_cls: {
    // marginTop: "20px !important",
    width: "38%",
    display: "block",
    marginRight:"6px",
    "&>div": {
      width: "100%",
      "&>div": {
        width: "100%",
      },
      "&>p": {
        margin: 0,
        fontSize: 12,
        lineHeight: "22px",
        display: "flex",
      },
    },
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
  },
  menuitem: {
    direction: "rtl",
  },
  menuitemhidden: {
    display: "none",
  },
}));

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// common dropdown component
export default function CommonDropDown({
  label = "",
  options = [],
  disabled = false,
  placeholder,
  defaultValue,
  onChangeAction,
  selectedValue = null,
  isloading,
  loadingMore = () => {},
  totalListCount = 0,
  type,
  required = false,
  enableTimeOptions = false,
  projectStartTime,
  endTime,
  ...props
}) {
  const classes = useStyle();
  const [setTarget, entry] = useIntersection({ threshold: 0.1 });
  const [value, setValue] = useState("none");

const generateTimeOptions = () => {
  const currentTime = moment();
  const projectStartTimeDate = moment(projectStartTime)
  const timeOptions = [];
  // if user dont punch in but try to select project in current time show no fields
  if(projectStartTime){
    var timeDifference = Math.floor((currentTime - projectStartTimeDate) / (1000 * 60));
  } else {
    return null;
    // var timeDifference = Math.floor((currentTime - currentTime) / (1000 * 60));
  }
  // Add time options in 15-minute intervals up to the time difference
  for (let timeInterval = 15; timeInterval <= timeDifference && timeInterval <= 120; timeInterval += 15) {
    const hours = Math.floor(timeInterval / 60);
    const minutes = timeInterval % 60;
    const timeString = `${hours > 0 ? hours + ' hr' : ''} ${minutes > 0 ? minutes + ' min' : ''}`;
    timeOptions.push({ id: timeString, label: timeString });
  }
  return timeOptions;
};
const timeOptions = generateTimeOptions();
  useEffect(() => {
    if (entry.isIntersecting) {
      if (totalListCount !== options?.length) {
        loadingMore();
      }
    }
  }, [entry]);

  return (
    <div className={classes.iih_selectbox_cls}>
      <FormControl className={classes.form}>
        <p>
          {label}{" "}
          {required && (
            <span style={{ color: "red", marginLeft: "5px" }}>*</span>
          )}
        </p>
        <Select
          value={selectedValue || value}
          onChange={onChangeAction}
          disabled={disabled}
          placeholder={placeholder}
          size="small"
          isloading={isloading}
          inputProps={
            {
              // shrink: true,
            }
          }
          MenuProps={MenuProps}
          {...props}
        >
          {isloading && options?.length === 0 && (
            <p className={classes.circularProgress}>Fetching data...</p>
          )}
          {type === "company" ? (
            <div></div>
          ) : placeholder ? (
            <MenuItem key="0" value="none">
              {placeholder}
            </MenuItem>
          ) : null}

          {enableTimeOptions &&
            timeOptions.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.label}
              </MenuItem>
            ))}

          {options?.map((option) => (
            <MenuItem key={option?.id} value={option?.id}>
              {option?.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
